// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import { AutocompleteItemModel, BrandAutocompleteModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { Fragment } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import { autocompleteProps } from "@store/Themes/common/props/autocomplete";
/* Starter Custom Code - End */

interface Props {
    brands: BrandAutocompleteModel[] | null;
    focusedItem?: AutocompleteItemModel;
    goToUrl: (url: string) => void;
    extendedStyles?: AutocompleteBrandsStyles;
}

export interface AutocompleteBrandsStyles {
    headerText?: TypographyPresentationProps;
    brandItemText?: TypographyPresentationProps;
    focusedBrandItemText?: TypographyPresentationProps;
    link?: LinkPresentationProps;
    focusedLink?: LinkPresentationProps;
    // Starter Custom Code
    note?: TypographyPresentationProps;
}

export const autocompleteBrandsStyles: AutocompleteBrandsStyles = {
    headerText: autocompleteProps.headerText,
    link: autocompleteProps.link,
    focusedLink: autocompleteProps.focusedLink,
    note: autocompleteProps.note,
};

const styles = autocompleteBrandsStyles;

class AutocompleteBrands extends React.Component<Props> {
    private readonly styles: AutocompleteBrandsStyles;

    constructor(props: Props) {
        super(props);

        this.styles = mergeToNew(styles, props.extendedStyles);
    }

    render() {
        const { brands } = this.props;
        if (!brands || brands.length === 0) {
            return null;
        }

        const styles = this.styles;
        return (
            <>
                <Typography
                    {...styles.headerText}
                    data-test-selector="autocompleteBrands_Header"
                    className="autocomplete-brands-header"
                >
                    {translate("Brands")}
                </Typography>
                {/* Starter Custom Code - Start */}
                <ul>
                    {brands.map(brand => (
                        <li key={`${brand.id}_${brand.productLineId}`}>
                            <Link
                                {...(this.props.focusedItem === brand ? styles.focusedLink : styles.link)}
                                onClick={() => {
                                    this.props.goToUrl(brand.url);
                                }}
                                data-test-selector={
                                    brand.productLineName
                                        ? `productLineId_${brand.productLineId}`
                                        : `brandId_${brand.id}`
                                }
                                className="autocomplete-brands-link"
                            >
                                {brand.productLineName ? (
                                    <>
                                        {brand.displayProductLineName}
                                        <Typography {...styles.note} className="autocomplete-brands-note">
                                            <>{` ${translate("in")}`}</> {brand.displayTitle}
                                        </Typography>
                                    </>
                                ) : (
                                    brand.displayTitle
                                )}
                            </Link>
                        </li>
                    ))}
                </ul>
                {/* Starter Custom Code - End */}
            </>
        );
    }
}

export default AutocompleteBrands;
